import React from 'react';
import ReactDOM from 'react-dom/client';
import { ProSidebarProvider } from "react-pro-sidebar";
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { PRIMARYCOLOR,SECONDARYCOLOR } from './Constants';

// Import PostHog
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

import { createTheme } from '@mui/material/styles';
import { ThemeProvider, CssBaseline } from '@mui/material';

const ignoredResizeObserverErrors = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

window.addEventListener('error', (event) => {
  if (ignoredResizeObserverErrors.includes(event.message)) {
    event.stopImmediatePropagation();
  }
});



// Hardcoded PostHog configuration
const POSTHOG_API_KEY = 'phc_AUxX5ROmrb0dnzHvvU7VpzlNuIvYX3H1Tdbd1EPLECV';
const POSTHOG_API_HOST = 'https://us.i.posthog.com';

// Initialize PostHog
posthog.init(POSTHOG_API_KEY, { api_host: POSTHOG_API_HOST });

// Function to get the token from sessionStorage
const getToken = () => sessionStorage.getItem('token');

// Decode the JWT token to extract its payload
const decodeToken = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload;
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
};

// Identify user in PostHog
const identifyUserInPostHog = () => {
  const token = getToken();
  const userDetails = token ? decodeToken(token) : null;

  if (userDetails && userDetails.username) {
    console.log('Identifying user:', userDetails.username);
    posthog.identify(userDetails.username, {
      username: userDetails.username
    });
  } else {
    console.info('No valid user token found; user remains anonymous.');
  }
};


export const theme = createTheme({
  palette: {
    primary: { main: PRIMARYCOLOR }, // your brand color
    secondary: { main: SECONDARYCOLOR }, // your secondary color
  },
});

// Call identify function before rendering
identifyUserInPostHog();

// Render React app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <ProSidebarProvider>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </ProSidebarProvider>
    </PostHogProvider>
  </React.StrictMode>
);
